import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import './blog.css';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Demo from '../components/Navbar';

const Blog = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const { id } = useParams();

    const blogs = [
        {
            id: 1,
            title: "Spotcomm's Managed Network Services",
            author: "Soaman Faruqi",
            date: "March 24, 2023",
            image: "/blog2.webp",
            link: "/blog/SeamlessIntegrationwithSpotcommManagedNetworkServices",
            summary: "Managed network services overview..."
        },
        {
            id: 2,
            title: "Technology and Client Ambition",
            author: "Soaman Faruqi",
            date: "Oct 26, 2024",
            image: "/blog3.webp",
            link: "/blog/TechnologyandClientAmbition"
        },
        {
            id: 3,
            title: "The Future Of Technology and Networking",
            author: "Soaman Faruqi",
            date: "Oct 20, 2024",
            image: "/blog4.webp",
            link: "/blog/TheFutureOfTechnologyandNetworking"
        },
        {
            id: 4,
            title: "The impact on Europe's Software Industry Network",
            author: "Soaman Faruqi",
            date: "Apr 4, 2025",
            image: "/blog45.webp",
            link: "/blog/TheImpactonEuropeSoftwareIndustryNetworkembracingCuttingEdgeCloudServicesTechnology"
        },
        {
            id: 5,
            title: "Rising Digital Threats Prompt Cybersecurity Surge in Asia’s Banking Sector",
            author: "Soaman Faruqi",
            date: "May 20, 2025",
            image: "/blog5.webp",
            link: "/blog/RisingDigitalThreatsPromptCybersecuritySurgeinAsia’sBankingSector"
        }
    ];

    const handleBlogClick = (blog) => {
        if (window.gtag) {
            window.gtag('event', 'blog_click', {
                blog_title: blog.title,
                blog_id: blog.id,
                author: blog.author,
                date: blog.date
            });
        }
    };



    const slugify = (text) =>
        text
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .trim();

    const updatedBlogs = blogs.map(blog => ({
        ...blog,
        link: '/' + slugify(blog.title)
    }));


    console.log(updatedBlogs);
    const [filterCategory, setFilterCategory] = useState("All category");
    const [filterIndustry, setFilterIndustry] = useState("Industries/Services");
    const [filterYear, setFilterYear] = useState("All year");

    const handleSearch = (query) => {
        setSearchQuery(query);
    };

   
    const filteredBlogs = blogs.filter(blog => {
        // Apply search filter
        if (searchQuery !== "") {
            const queryWords = searchQuery.toLowerCase().split(" ").slice(0, 3).join(" ");
            if (!blog.title.toLowerCase().startsWith(queryWords)) {
                return false;
            }
        }

        // Apply category filter
        if (filterCategory !== "All category" && blog.title.indexOf(filterCategory) === -1) {
            return false;
        }

        // Apply year filter
        if (filterYear !== "All year" && !blog.date.includes(filterYear)) {
            return false;
        }

        return true;
    });

    return (
        <div>
            <Header />
            <section id="heros" className="heros1 section dark-background">
                <img src="/blog.webp" alt="" />
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <h2 className='profh2'>Blog</h2>
                        </div>
                    </div>
                </div>
            </section>
            <div className="blog-page">
                <aside className="sidebar">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                    <div className="filters">
                        <label>Filter</label>
                        <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
                            <option>All category</option>
                            <option>Software</option>
                            <option>Technology</option>
                        </select>

                        {/* <select value={filterIndustry} onChange={(e) => setFilterIndustry(e.target.value)}>
                            <option>Industries/Services</option>
                            <option>Service 1</option>
                            <option>Service 2</option>
                        </select> */}
                        <select value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
                            <option>All year</option>
                            <option>2025</option>
                            <option>2024</option>
                            <option>2023</option>
                        </select>
                    </div>
                </aside>
                <main className="content">
                    {/* <div className="featured-blog">
                        {filteredBlogs.filter(blog => blog.featured).map(blog => (
                            <div key={blog.title} className="featured-card">
                                <h3>{blog.title}</h3>
                                <p>{blog.author}</p>
                                <p>{blog.date}</p>
                            </div>
                        ))}
                    </div> */}

                    <div className="blog-grid h-auto">

                        {filteredBlogs.filter(blog => !blog.featured).map(blog => (

                            <div key={blog.id} className="blog-card">
                                <img src={blog.image} alt={blog.title} />
                                <h3 className=''>{blog.title}</h3>
                                <p>{blog.author}</p>
                                <p>{blog.date}</p> 
                                {/* <Link to={blog.link} onClick={() => handleBlogClick(blog)}>
                                    <button className="btns21 d-block mx-3">Read More</button>
                                </Link> */}

                                <Link
                                    to={blog.link}
                                    key={blog.id}
                                    onClick={() => handleBlogClick(blog)}
                                    className="blog-card"
                                ><button className="btns21 d-block mx-3">Read More</button></Link>
                                <br />
                            </div>
                        ))}
                    </div>
                </main>
            </div>
            <Demo />

        </div>
    );
};

export default Blog;
